<div class="module module-products template-{{data.template}}">
    <div class="module-title">
        <div class="container">
            <div class="title">
                <h2 class="wow slideInLeft">{{data.titulo}}</h2>
                <h3 class="wow slideInUp">{{data.subtitulo}}</h3>
            </div>
        </div>    
    </div>
    <div class="module-content">
        <div class="container"> 
            <div class="products slider-items" #slider>  
                <div class="slider-item" *ngFor="let p of data.data">
                    <produto-item-two *ngIf="data.template == 1" [data]="p"></produto-item-two>
                    <produto-item *ngIf="data.template == 2" [data]="p"></produto-item>
                </div>
            </div>
            <div class="slide-navigate-item prev" (click)="prev()">
                <img width="40px" height="40px" src="/images/icons/prev.svg" alt="Prev" />
            </div>
            <div class="slide-navigate-item next" (click)="next()">
                <img width="40px" height="40px" src="/images/icons/next.svg" alt="Next" />
            </div> 
        </div>
    </div> 
</div> 
